import {
  isFactorialIdUser,
  refreshFactorialIdToken,
} from 'modules/core/lib/factorialIdTokenRefresh'

const AUTH_RETRY_STATUSES = new Set([401, 403])
const REFRESH_THRESHOLD_MS = 20 * 60 * 1000

const withDefaultCredentials = (init: RequestInit | undefined): RequestInit => ({
  ...init,
  credentials: init?.credentials ?? 'include',
})

function isFactorialIdTokenExpiringSoon(): boolean {
  const match = document.cookie.match(/(?:^|;\s*)_factorial_id_data=([^;]+)/)
  if (!match) return true
  try {
    const payload = JSON.parse(decodeURIComponent(match[1] ?? ''))
    return typeof payload.exp !== 'number' || Date.now() > payload.exp * 1000 - REFRESH_THRESHOLD_MS
  } catch {
    return true
  }
}

export const refreshFactorialIdTokenForOneIfNeeded = async (force = false): Promise<boolean> => {
  if (!isFactorialIdUser()) return false
  if (!force && !isFactorialIdTokenExpiringSoon()) return false

  const refreshed = await refreshFactorialIdToken()

  if (!refreshed) {
    throw new Error('Unable to refresh Factorial ID token before One request')
  }

  return true
}

export const createOneRuntimeFetch = (runtimeFetch: typeof fetch = fetch): typeof fetch => {
  return async (input, init) => {
    const isFactorialIdRequest = isFactorialIdUser()
    if (isFactorialIdRequest) {
      await refreshFactorialIdTokenForOneIfNeeded()
    }
    const requestInit = withDefaultCredentials(init)
    const request = new Request(input, requestInit)
    const response = await runtimeFetch(request.clone())

    if (!isFactorialIdRequest || !AUTH_RETRY_STATUSES.has(response.status)) return response

    await refreshFactorialIdTokenForOneIfNeeded(true)
    return runtimeFetch(request.clone())
  }
}
